<section class="bg-white q-pt-lg q-articulo">
    <div class="container py-4 text-center">
        <h1 class="text-blue-qaira font-weight-bolder">LA EDUCACIÓN AMBIENTAL ES TAREA DE TODOS</h1>
    </div>
</section>

<section class="bg-white q-articulo">
    <div class="container">
        <div class="row">
            <div class="col-md-12 col-lg-7">
                <p>
                    El tema de educación ambiental es la índole holística que hoy en día tiende a ser prioritaria en
                    múltiples
                    aspectos conectados con el enfoque ambiental, que propicia a su vez una relación de compromiso
                    sociocultural, de diversidad e interculturalidad que ha permitido al ser humano adaptarse a
                    distintas
                    condiciones del ambiente.
                </p>
                <p>
                    En 1975, cuando se celebraba el Seminario Internacional de la Educación Ambiental en Belgrado,
                    Yugoslavia;
                    se planteó el concepto arraigado a Educación Ambiental en la Carta de Belgrado, el cual señala
                    <b>“formar
                        una
                        población mundial consciente y preocupada con el medio ambiente y con los problemas asociados,
                        que tenga
                        conocimiento, aptitud, actitud, motivación y compromiso para trabajar individual y
                        colectivamente en la
                        búsqueda de soluciones para los problemas existentes y para prevenir nuevos”.</b>
                </p>

            </div>
            <div class="col-sm-12 col-md-5 text-center q-imagen-p">
                <img src="../../../assets/img/articulos/q-educacion-ambiental-quira.png" alt="">
            </div>
        </div>
        <p>
            Desde ese entonces se fue forjando una línea de actores, grupos de educación superior, colectivos
            gubernamentales entre otras agrupaciones con un enfoque ambiental en vías de generar y mantener una
            sociedad
            más justa y sostenible con su entorno. A razón de ello, el concepto de educación ambiental apunta a
            una
            educación integral impuesta al individuo a lo largo de toda su vida generando acciones de mejora,
            emociones,
            actitudes y comportamientos que permitan desarrollarse respetando la continuidad de las distintas
            formas de
            vida en el planeta.
        </p>
        <h5 class="q-pt-20">PANORAMA ACTUAL DE LA EDUCACIÓN AMBIENTAL</h5>

        <div class="row">
            <div class="col-md-12 col-lg-7">
                <p>
                    Actualmente en nuestro país existen dos instrumentos para gestionar la educación ambiental: la
                    Política
                    Nacional de Educación Ambiental (PNEA) y el Plan Nacional de Educación Ambiental 2016 – 2021
                    (PLANEA). Sobre
                    la base de estos instrumentos el Ministerio de Educación ha llevado a cabo programas y cursos de
                    educación
                    ambiental para docentes y alumnos. Por su parte, el Ministerio del Ambiente brinda material
                    educativo para
                    estudiantes, docentes y gestores municipales en la plataforma virtual Aula Ambiental, portal del
                    cual qAIRa
                    también es parte a través de nuestra campaña para reforzar la educación ambiental entre los niños y
                    niñas
                    del país. Este proyecto se llevó a cabo durante el 2021 de la mano con UNICEF. En el ámbito
                    municipal y
                    local se ha desarrollado el programa EDUCCA (Programa Municipal de Educación, Cultura y Ciudadanía
                    Ambiental) para fomentar la participación ciudadana en la gestión ambiental. Estas estrategias han
                    generado
                    que en el año 2021, 46% de las 93745 instituciones educativas a nivel nacional reporten sus logros
                    ambientales y el 44% de los gobiernos locales tengan un programa EDUCCA.
                </p>
            </div>
            <div class="col-sm-12 col-md-5 text-center q-imagen-p">
                <img src="../../../assets/img/articulos/educacion-ambiental-qairita.png" alt="">
            </div>
        </div>

        <p>
            Un ejemplo es lo que viene realizando la Municipalidad Metropolitana de Lima en conjunto con los ciudadanos
            de la capital. En el 2020, se generaron 24 proyectos ambientales concretizados, desde temas de gestión de
            residuos hasta los relacionados a mejoras de calidad de vida. Además, más de 5000 personas participaron en
            las actividades de promoción cultural-ambiental.
        </p>
        <p>
            A inicios del 2022, lo que se requiere es una actualización de estos instrumentos a un contexto actual de
            educación virtual por la pandemia por la COVID-19, así como la implementación de estos programas en zonas
            rurales y la adaptación de los recursos educativos en lenguas originarias.
        </p>

        <h5 class="q-pt-20">¿QUÉ TENEMOS POR DELANTE? </h5>
        <p>
            Es importante tomar consciencia en las múltiples actividades de la humanidad en diversas formas y calidad de
            la vida actual y futuras; es por ello que las opciones y alternativas planteadas ayudarán con la forma de
            actuar, aportar y conservar durante su vida. Por ello es importante lo siguiente:
        </p>
        <ul>
            <li>Que las personas comprendan que la conexión con el medio ambiente es recíproca, y que si alguna acción
                perjudica o altera su entorno tendrá una consecuencia indirecta sobre la ciudadanía.</li>
            <li>Que se incorporen temas como el cambio climático, conservación de la biodiversidad, gestión de residuos
                sólidos, entre otros, en las escuelas y universidades para desarrollar una cultura ambiental durante la
                etapa de formación. </li>
            <li>Fomentar la búsqueda de información de programas de educación ambiental de su localidad y las
                actividades que vienen realizando con el fin de impulsar la participación ciudadana responsable.</li>
            <li>Tener un conocimiento general de cómo resolver los problemas ambientales basado en información certera y
                confiable.</li>
        </ul>

        <p>
            <b>La educación ambiental es un proceso de formación al individuo para desempeñar un papel crítico en la
                sociedad, el objetivo es establecer una armoniosa interacción con la naturaleza. Tomemos conciencia que
                todas nuestras acciones son y serán relevantes y repercuten en el medio. No seamos agentes pasivos,
                comencemos con el cambio que la naturaleza nos necesita.
            </b>
        </p>
        <div>
            <div class="text-p"><b>Autoría:</b> Equipo Ambiental qAIRa</div>
            <div class="text-p"><b>Contacto:</b> ambiental@qairadrones.com</div>
        </div>
        <div class="mt-4">
            <div><b>Fuentes bibliográficas:</b></div>
            <ul class="mt-1">
                <li><a href="http://www.scielo.org.mx/scielo.php?script=sci_arttext&pid=S1405-66662012000400002">Investigación en educación ambiental</a></li>
                <li><a href="https://www.sib.gob.ar/portal/wp-content/uploads/2019/02/Seminario-Internacional-de-Educaci%C3%B3n-Ambiental-Carta-de-Belgrado-1975.pdf">Seminario Internacional de Educación Ambiental 1975</a></li>
                <li><a href="https://biblioteca.semarnat.gob.mx/janium/Documentos/Ciga/Libros2013/CD002213.pdf">Educación Ambiental y acción colectiva municipal, Mexico 2014</a></li>
                <li><a href="https://www.minam.gob.pe/wp-content/uploads/2013/10/politica_nacional_educacion_ambiental_amigable_11.pdf">Política Nacional de Educación Ambiental amigable, Perú 2012</a></li>
                <li><a href="http://www.minedu.gob.pe/educacion-ambiental/ambiental/sumilla_planea.php">PLANEA, Perú 2016-2021. Plan de acción de Educación Ambiental</a></li>
                <li><a href="https://aulaambiental.minam.gob.pe/">Ministerio del Ambiente. 2021. Aula Ambien</a></li>
                <li><a href="https://www.facebook.com/perueduca/videos/1575975566090607/?extid=CL-UNK-UNK-UNK-AN_GK0T-GK1C&ref=sharing">Portal PerúEduca. Webinar: Retos y perspectivas de la educación ambiental en el Perú. La hora ambiental.</a></li>
            </ul>
        </div>
    </div>
</section>